import { AbstractControl } from "@angular/forms";
import { ControlUtil } from "src/app/base/shared/utils/control-util";
import { ConfigurationFormTimeplanErrors, ConfigurationFormTimeplanErrorsKeys } from "./configuration-form-timeplan.errors";

export class ConfigurationFormTimeplanValidators {
  public static allWeekdaysValidator(control: AbstractControl): {[key: string]: any} | null {
    const result = control.get('allowedMonday')?.value ||
                    control.get('allowedTuesday')?.value ||
                    control.get('allowedWednesday')?.value ||
                    control.get('allowedThursday')?.value ||
                    control.get('allowedFriday')?.value ||
                    control.get('allowedSaturday')?.value ||
                    control.get('allowedSunday')?.value;
    if (result) {
      return null;
    }
    return {required: true};
  }

  public static dayPickerValueValidation(control: AbstractControl): {[key: string]: any} | null {
    if (control.value > 0) {
      return null;
    }
    return { required: true };
  }

  public static checkStartAndEndTime(c: AbstractControl) {
    const startTimeControl = c.get('startTime');
    const endTimeControl = c.get('endTime');
    if (!startTimeControl || !startTimeControl.value || !endTimeControl || !endTimeControl.value) {
      ControlUtil.setError(endTimeControl, ConfigurationFormTimeplanErrors.getEndTimeErrors(), ConfigurationFormTimeplanErrorsKeys.startTimeEndTimeOrder, false);
      return null;
    }
    const startTime = startTimeControl.value as Date;
    const endTime = endTimeControl.value as Date;
    const startTimeInMinutes = startTime.getHours() * 60 + startTime.getMinutes();
    const endTimeInMinutes = endTime.getHours() * 60 + endTime.getMinutes();
    if (startTimeInMinutes > endTimeInMinutes) {
      ControlUtil.setError(endTimeControl, ConfigurationFormTimeplanErrors.getEndTimeErrors(), ConfigurationFormTimeplanErrorsKeys.startTimeEndTimeOrder, true);
      endTimeControl.markAsDirty();
      return null;
    } else {
      //Remove error state
      ControlUtil.setError(endTimeControl, ConfigurationFormTimeplanErrors.getEndTimeErrors(), ConfigurationFormTimeplanErrorsKeys.startTimeEndTimeOrder, false);
      return null;
    }
  }

  public static checkStartAndEndDate(c: AbstractControl) {
    const startDateControl = c.get('startDate');
    const endDateControl = c.get('endDate');
    const today = ConfigurationFormTimeplanValidators.resetTime(new Date());


    if (!startDateControl || !startDateControl.value || !endDateControl || !endDateControl.value) {
      ControlUtil.setError(endDateControl, ConfigurationFormTimeplanErrors.getEndTimeErrors(), ConfigurationFormTimeplanErrorsKeys.startTimeEndTimeOrder, false);
      return null;
    }
    const startDate = ConfigurationFormTimeplanValidators.resetTime(startDateControl.value as Date);
    const endDate = ConfigurationFormTimeplanValidators.resetTime(endDateControl.value as Date);
    if (startDate.getTime() > endDate.getTime()) {
      ControlUtil.setError(endDateControl, ConfigurationFormTimeplanErrors.getEndTimeErrors(), ConfigurationFormTimeplanErrorsKeys.endDateBeforeToday, false);
      ControlUtil.setError(endDateControl, ConfigurationFormTimeplanErrors.getEndTimeErrors(), ConfigurationFormTimeplanErrorsKeys.startDateEndDateOrder, true);
      endDateControl.markAsDirty();
      return null;
    } else if(endDate.getTime() < today.getTime()) {
      ControlUtil.setError(endDateControl, ConfigurationFormTimeplanErrors.getEndTimeErrors(), ConfigurationFormTimeplanErrorsKeys.startDateEndDateOrder, false);
      ControlUtil.setError(endDateControl, ConfigurationFormTimeplanErrors.getEndTimeErrors(), ConfigurationFormTimeplanErrorsKeys.endDateBeforeToday, true);
    } else {
      //Remove error state
      ControlUtil.setError(endDateControl, ConfigurationFormTimeplanErrors.getEndTimeErrors(), ConfigurationFormTimeplanErrorsKeys.startDateEndDateOrder, false);
      ControlUtil.setError(endDateControl, ConfigurationFormTimeplanErrors.getEndTimeErrors(), ConfigurationFormTimeplanErrorsKeys.endDateBeforeToday, false);
      return null;
    }
  }

  private static resetTime(date: Date): Date {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date
  }
}
